<script setup>
import {GenderLabel, IsChildLabel} from "@/choices";
import {unitType} from "@/components/hpo/utils";
import Hospital from "@/components/hpo/dashboard/patientListItems/td/Hospital.vue";
import Status from "@/components/hpo/dashboard/patientListItems/td/Status.vue";
import {convertPriorityToColor, HpoTransportStatus, PriorityLabel} from "@/components/hpo/choices";
import {computed} from "vue";
import {useBlinking} from "@/components/alert-ticker";
import {mdiGestureTap} from "@mdi/js";
import {pgettext} from "../../../../utils/translate";
import {HospitalTypeLabel} from "../../choices";

const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    alertList: {
        type: Array,
        required: true
    },
    now: {
        type: Object,
        required: true
    },
});
const emit = defineEmits(['setEditedTransportData', 'openReplyModal', 'displayActionsModal', 'displayTransportWizard']);

function handleOpenActionsModal() {
    emit('displayActionsModal', props.patient);
}

function handleSetEditedTransportData(patient) {
    emit('setEditedTransportData', patient);
}

function handleOpenReplyModal(data, patient) {
    emit('openReplyModal', data, patient);
}

function handleEditTransport() {
    emit('displayTransportWizard', props.patient);
}

const isAlert = computed(() => {
    return props.alertList.includes(parseInt(props.patient.id))
})

const isBlinkActive = useBlinking(() => isAlert.value);
const bgColor = computed(() => isBlinkActive.value ? 'red-lighten-5' : null);
</script>

<template>
    <v-card :color="bgColor" class="hpo-patients-list-evac-manager__patient" border="sm">
        <v-card-text class="hpo-patients-list-evac-manager__patient-content">
            <div class="hpo-patients-list-evac-manager__patient-actions">
                <v-btn @click="handleOpenActionsModal" class="px-1"
                       :prepend-icon="mdiGestureTap">
                <span class="text-wrap">{{ pgettext('label', 'Options') }}</span>
                </v-btn>
            </div>
            <div class="hpo-patients-list-evac-manager__patient-tic">
                {{ patient.ticPrefix }}{{ patient.ticNumber }}
            </div>
            <div class="hpo-patients-list-evac-manager__patient-priority">
                <v-chip v-if="patient.transportPriority" density="compact" variant="flat" size="large" :ripple="false"
                        :color="convertPriorityToColor(patient.transportPriority).toLowerCase()" rounded class="py-0 px-5">
                    <strong>{{ PriorityLabel[patient.transportPriority] }}</strong>
                </v-chip>
            </div>
            <div class="hpo-patients-list-evac-manager__patient-gender">
                {{ GenderLabel[patient.gender] }} &ndash; {{ IsChildLabel[patient.isChild] }}
            </div>
            <div class="hpo-patients-list-evac-manager__patient-unit">
                {{ unitType(patient.unitType, patient.unitTypeSpec) }}
                {{ patient.callSign }}
            </div>
            <div class="hpo-patients-list-evac-manager__patient-ward">
                {{ HospitalTypeLabel[patient.hospitalType] }}
            </div>
            <div class="hpo-patients-list-evac-manager__patient-hospital">
                <Hospital v-if="patient.transportStatus !== HpoTransportStatus.DRAFT"
                          :patient="patient" :member="member" :now="now"
                          @setEditedTransportData="handleSetEditedTransportData"
                          @openReplyModal="handleOpenReplyModal"/>
                <v-btn v-else density="compact" @click="handleEditTransport">
                    {{ pgettext('action', 'Edit Transport') }}
                </v-btn>
            </div>
            <div class="hpo-patients-list-evac-manager__patient-status">
                <Status :alertList="alertList" :member="member" :patient="patient"/>
            </div>
        </v-card-text>
    </v-card>
</template>
